export const accountMenu = {
  roles: {
    collaborator: "Colaborador",
    hostMode: "Modo anfitrião",
  },
  header: {
    collaboratorAccess: "Acesso de colaborador",
  },
  panel: {
    label: "Visualização do painel",
    apartment: "Apartamento",
    hotel: "Hotel",
  },
  groups: {
    navigate: "Navegar",
    manage: "Gerenciar",
  },
  items: {
    home: "Início",
    bookings: "Reservas",
    myAccount: "Minha conta",
    myAccommodations: "Minhas acomodações",
    aiReception: "Recepção com IA",
    aiReceptionist: "Recepcionista com IA",
    directBookings: "Reservas diretas",
    website: "Site",
    logout: "Sair",
  },
  badges: {
    ai: "IA",
    new: "NOVO",
  },
  actions: {
    close: "Fechar",
  },
};
